import { render, staticRenderFns } from "./MemberManagement.vue?vue&type=template&id=68cb8686&scoped=true"
import script from "./MemberManagement.vue?vue&type=script&lang=js"
export * from "./MemberManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cb8686",
  null
  
)

export default component.exports